import { render, staticRenderFns } from "./AddPromActivity.vue?vue&type=template&id=d2065eb8&scoped=true"
import script from "./AddPromActivity.vue?vue&type=script&lang=js"
export * from "./AddPromActivity.vue?vue&type=script&lang=js"
import style0 from "./AddPromActivity.vue?vue&type=style&index=0&id=d2065eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2065eb8",
  null
  
)

export default component.exports